import { render } from "./OrderFavoriteDetail.vue?vue&type=template&id=773e7abc"
import script from "./OrderFavoriteDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderFavoriteDetail.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/orderFavoriteDetail/OrderFavoriteDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "773e7abc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('773e7abc', __exports__)) {
    console.log('reload')
    api.reload('773e7abc', __exports__)
  }
  
  module.hot.accept("./OrderFavoriteDetail.vue?vue&type=template&id=773e7abc", () => {
    console.log('re-render')
    api.rerender('773e7abc', render)
  })

}


export default __exports__